<template>
    <div>
        <v-container>
            <div class="page-tournaments">
                <div class="page-tournaments__title">
                    <i class="icon"></i>
                    <div class="text">
                        <h2>{{ $t('front.tournament.page.title') }}</h2>
                        <p>{{ $t('front.tournament.page.description') }}</p>
                    </div>
                </div>
                <div class="page-tournaments__navTabs" v-if="isMobile">
                    <div class="navTabs">
                        <div class="navTabs__item"
                             :class="{active: activeTab === 'live'}"
                             @click="activeTab = 'live'">
                            {{ $t('front.tournament.tabs.live') }}
                        </div>
                        <div class="navTabs__item"
                             :class="{active: activeTab === 'upcoming'}"
                             @click="activeTab = 'upcoming'">
                            {{ $t('front.tournament.tabs.upcoming') }}
                        </div>
                        <div class="navTabs__item"
                             :class="{active: activeTab === 'finished'}"
                             @click="activeTab = 'finished'">
                            {{ $t('front.tournament.tabs.ended') }}
                        </div>
                    </div>
                </div>

                <tournament-part v-if="active"
                                 :reference="`live`"
                                 :active="activeTab"
                                 :items="active"
                                 :priority="activePriority"
                                 :delay="activeDelay"/>

                <tag-news-slider :newsTags="['tournaments']" :title="$t('front.news.slider.tournament_title')" :hideSeeAllButton="true" v-if="showNewsSlider"/>

                <tournament-part v-if="pending"
                                 :reference="`upcoming`"
                                 :active="activeTab"
                                 :items="pending"
                                 :priority="pendingPriority"
                                 :delay="pendingDelay"/>

                <tournament-part v-if="awarded"
                                 :reference="`finished`"
                                 :active="activeTab"
                                 :items="awarded"
                                 :priority="awardedPriority"
                                 :delay="awardedDelay"/>
            </div>
        </v-container>

        <!--        <advanced-signup/>-->
    </div>
</template>

<script>
import apiData from "../../../../mixins/apiData";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import {showNewsSliderOnTournamentsPage} from "../../../../../config/tournament";

export default {
    name: "Tournaments",

    components: {
        Swiper,
        SwiperSlide,
    },

    mixins: [apiData],

    data: function () {
        return {
            isMobile: this.$store.state.isDeviceMobile,
            activeTab: 'live',
            showNewsSlider: showNewsSliderOnTournamentsPage,
        }
    },

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData();
    },

    computed: {
        active() {
            return this.$store.state.tournament.list.active;
        },

        pending() {
            return this.$store.state.tournament.list.pending;
        },

        awarded() {
            return this.$store.state.tournament.list.awarded;
        },

        activePriority() {
            return this.active.length ? 1 : 0;
        },

        pendingPriority() {
            return this.pending.length ? this.activePriority + 1 : this.activePriority;
        },

        awardedPriority() {
            return this.awarded.length ? this.pendingPriority + 1 : this.pendingPriority;
        },

        activeDelay() {
            return false;
        },

        pendingDelay() {
            return this.pendingPriority !== this.activePriority;
        },

        awardedDelay() {
            return this.awardedPriority !== this.pendingPriority;
        },
    },

    methods: {
        fetchData() {
            return this.$store.dispatch('FETCH_TOURNAMENTS', this.createApiData());
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/pages/parts/target/Tournaments"
</style>